import React, { useEffect, useState } from 'react';
import { Col, Form, InputNumber, Layout, message, Row } from 'antd';
import { get } from 'lodash';

import PdButton from 'components/pd-button';
import { errHandling } from 'utils';

import ResellerServices from 'services/reseller';
import { useNavigate, useLocation } from 'react-router-dom';

const { Content } = Layout;

export function ResellersCashbackCreateEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const [dealer, setDealer] = useState({
    title: 'dealer',
    id: null,
    cashback_percentage: null,
  });
  const [individual, setIndividual] = useState({
    title: 'individual',
    id: null,
    cashback_percentage: null,
  });

  const handleSubmit = async () => {
    delete dealer.title;
    delete individual.title;
    if (dealer && individual) {
      try {
        await ResellerServices.updateResellerCashback([dealer, individual]);
        const prevPath = get(location, 'state.prevPath', '/resellers_cashback');
        message.success('Successfully update cashback type');
        navigate(prevPath);
      } catch (error) {
        errHandling(error);
      }
    } else {
      message.error('Cannot connect to server, please check connection');
    }
  };

  const changeDealer = (value) => {
    const cashback_percentage = value;
    setDealer({ ...dealer, cashback_percentage });
  };

  const changeIndividual = (value) => {
    const cashback_percentage = value;
    setIndividual({ ...individual, cashback_percentage });
  };

  const setDefaultValue = async () => {
    try {
      const { data } = await ResellerServices.getResellerTypes();
      const types = get(data, 'data', []);
      setDealer(types.find((el) => el.title === 'dealer'));
      setIndividual(types.find((el) => el.title === 'individual'));
    } catch (error) {
      errHandling(error);
    }
  };

    const formItemLayout = {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 },
        }

  useEffect(() => {
    setDefaultValue();
    // eslint-disable-next-line
  }, []);

  return (
    <Layout className="pd-cms-durations main-container">
      <div className="content">
        <div className="pageTitle">Change Cashback</div>
        <Content>
          <Form onFinish={handleSubmit}>
            <div className="section-container">
              <div className="inner-section">
                <Row gutter={[4,4]} >
                  <Col span={8}>
                    <Form.Item  label="Dealer" labelCol={{ span: 3 }} {...formItemLayout}>
                        <InputNumber
                          className="inputForm"
                          value={dealer.cashback_percentage}
                          step={1}
                          onChange={changeDealer}
                            suffix={'%'}
                        />
                    </Form.Item>
                  </Col>
                    <Col span={8}>
                  <Form.Item label="Individual" labelCol={{ span: 3 }} {...formItemLayout}>
                      <InputNumber
                        className="inputForm"
                        value={individual.cashback_percentage}
                        step={1}
                        onChange={changeIndividual}
                        suffix={'%'}
                      />
                  </Form.Item>
                    </Col>
                </Row>
              </div>
            </div>

            <div className="section-container">
              <Form.Item>
                <div className="buttonSection">
                  <PdButton htmlType="submit" type="primary" full>
                    Publish
                  </PdButton>
                </div>
              </Form.Item>
            </div>
          </Form>
        </Content>
      </div>
    </Layout>
  );
}

export default { ResellersCashbackCreateEdit };
